import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(
  (theme) => ({
    termometre: {
      width: "100%",
      height: 12,
      borderRadius: 5,
      border: "1px rgb(200,200,200) solid",
    },
    targetContainer: { width: "100%" },
    gutterBottom: { marginBottom: theme.spacing(2) },
    targetTextContainer: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      marginBottom: theme.spacing(1),
      [theme.breakpoints.up("md")]: { marginTop: theme.spacing(1) },
    },
    targetText: { marginLeft: theme.spacing(0.5) },
  }),
  { index: 10 }
);
